/**
 * components/ExpensesContext.js
 * Hands the Biaya Lain-Lain / Pengeluaran list (`data.expenses`) to every reader that needs a
 * transaction's own costs — TransactionDetailModal, TotalSetelahBiayaCell, the transaction
 * form's Biaya Lain-Lain box, and the HPP readers — without threading a new prop through each
 * of the five pages that host them (2026-10-11). App.js is the only provider.
 *
 * The default (no provider — e.g. a component test mounting a page or modal on its own) is an
 * empty list, so every existing render stays exactly as it was.
 */
import React, { createContext, useContext } from "react";
import { expensesForTxn, sumExpenses } from "../utils/expenses";
import { fmtQty } from "../utils/idGenerators";

export const ExpensesContext = createContext({ expenses: [] });

export function useExpenses() {
  return useContext(ExpensesContext);
}

/** The "Hapus transaksi?" warning's extra line: deleting a transaction deletes its Biaya
 *  Lain-Lain too (2026-10-11), so it says so first — e.g. "Biaya lain-lain transaksi ini
 *  (1 baris, Rp 10.000) ikut dihapus." Renders nothing when the transaction has none. */
export function LinkedExpensesDeleteNote({ txnId }) {
  const { expenses } = useExpenses();
  const linked = expensesForTxn(expenses, txnId);
  if (linked.length === 0) return null;
  return (
    <span className="linked-expenses-delete-note">
      {" "}Biaya lain-lain transaksi ini ({linked.length} baris, Rp {fmtQty(sumExpenses(linked))}) ikut dihapus.
    </span>
  );
}
